import { MAX_TEXT_INPUT_VALIDATION } from "@/constants/common";
import { PATTERN } from "@/constants/pattern";
import { validator } from "@/utils/validator";

export const subjectSchema = validator.object().shape({
  // 基本情報
  subjectName: validator.string().trim().emptyToNull().max(100).label("WEEK名").required(),
  internalNote: validator.string().trim().emptyToNull().max(MAX_TEXT_INPUT_VALIDATION).label("社内メモ").notRequired(),
  status: validator.string().label("ステータス").notRequired(),
  activationDate: validator.string().label("有効化日").notRequired(),
  // 単語・問題データ
  vocabularySpreadsheetUrl: validator
    .string()
    .trim()
    .emptyToNull()
    .max(MAX_TEXT_INPUT_VALIDATION)
    .matches(PATTERN.CUSTOM_URL, "正しいURL形式で入力してください。")
    .label("単語データのスプレッドシートURL")
    .required(),
  problemSpreadsheetUrl: validator
    .string()
    .trim()
    .emptyToNull()
    .max(MAX_TEXT_INPUT_VALIDATION)
    .matches(PATTERN.CUSTOM_URL, "正しいURL形式で入力してください。")
    .label("問題データのスプレッドシートURL")
    .required(),
  sectionDivision: validator.string().trim().emptyToNull().label("パート").isSelection().required(),
  problemScoreAllocation: validator.string().trim().emptyToNull().label("問題の配点").notRequired(),
  mockExamQuestionCount: validator.string().trim().emptyToNull().label("模擬試験の出題数").notRequired(),
  fullScore: validator.string().label("満点").notRequired(),
  passingLineQuestionCount: validator.string().trim().emptyToNull().label("合格ライン(問題数)").notRequired(),
  passingScore: validator.string().label("合格点").notRequired(),
  // テキスト解説
  textExplanationFile: validator.mixed().notRequired(),
  textExplanationFileUrl: validator.string().nullable().notRequired(),
  textExplanationPageCount: validator.number().autoTransformToHalfWidth().label("ページ数").notRequired(),
  textExplanationInternalNote: validator
    .string()
    .trim()
    .emptyToNull()
    .max(MAX_TEXT_INPUT_VALIDATION)
    .label("テキスト解説に関する社内メモ")
    .notRequired(),
});
